import * as React from 'react';
import { connect } from 'react-redux';

// Components
import { DefaultWrapper } from '../../../components/Layout/DefaultWrapper';
import MenuOpener from '../../../components/MenuOpener';
import Footer from '../../../components/Layout/Footer';

// Screens
import Feature from './screens/Feature';
import HowWeDidItScreen from './screens/HowWeDidIt';
import BespokeScreen from './screens/Bespoke';
import CMSScreen from './screens/CMS';
import AccreditedScreen from './screens/Accredited';
import CounterScreen from './screens/Counter';
import FooterScreen from './screens/Footer';

const MakingOfAnIndustryLeader = () => (
  <DefaultWrapper>
    {/* menu */}
    <MenuOpener className="menu-opener" />
    {/* Screens */}
    <Feature />
    <HowWeDidItScreen />
    <BespokeScreen />
    <CMSScreen />
    <AccreditedScreen />
    <CounterScreen />
    <FooterScreen />
    <Footer />
  </DefaultWrapper>
);

export default connect()(MakingOfAnIndustryLeader);



// WEBPACK FOOTER //
// ./src/pages/CaseStudies/MakingOfAnIndustryLeader/index.jsx